import { createAction, props } from '@ngrx/store';
import { AiFunctionCall, ProjectChannelMessage, ProjectChannelMessageSendChannelMessageRequestDto, ProjectChannelMessageWithRelations } from '@rappider/rappider-sdk';
import { IChatMessage } from 'libs/components/src/lib/utils/chat';

export enum ActionTypes {
  CreateChannelMessage = '[AIAssistant] CreateChannelMessage',
  CreateChannelMessageSuccessful = '[AIAssistant] CreateChannelMessageSuccessful',
  SendDirectMessage = '[AIAssistant] SendDirectMessage',
  SendDirectMessageSuccessful = '[AIAssistant] SendDirectMessageSuccessful',
  CreateChatMessageFailure = '[AIAssistant] CreateChatMessageFailure',
  CreateAIFunction = '[AIAssistant] CreateAIFunction',
  CreateAIFunctionSuccessful = '[AIAssistant] CreateAIFunctionSuccessful',
  SetProjectChannels = '[AIAssistant] SetProjectChannels',
  RealtimeTypingCompleted = '[AIAssistant] RealtimeTypingCompleted',
  GetChannelMessagesByTimestamp = '[AIAssistant] GetChannelMessagesByTimestamp',
  GetChannelMessagesByTimestampSuccessful = '[AIAssistant] GetChannelMessagesByTimestampSuccessful',
  GetDirectMessagesByTimestamp = '[AIAssistant] GetDirectMessagesByTimestamp',
  GetDirectMessagesByTimestampSuccessful = '[AIAssistant] GetDirectMessagesByTimestampSuccessful',
  AnalyzeDataSource = '[AIAssistant] AnalyzeDataSource',
  AnalyzeDataSourceSuccessful = '[AIAssistant] AnalyzeDataSourceSuccessful',
  AnalyzeDataSourceFailure = '[AIAssistant] AnalyzeDataSourceFailure',
  GetAnalyzeMessages = '[AIAssistant] GetAnalyzeMessages',
  GetAnalyzeMessagesSuccessful = '[AIAssistant] GetAnalyzeMessagesSuccessful',
  GetAnalyzeMessagesFailure = '[AIAssistant] GetAnalyzeMessagesFailure',
  ResetSenderMessageStatus = '[AIAssistant] ResetSenderMessageStatus',
  Error = '[AIAssistant] Error'
}


export const GetChannelMessagesByTimestamp = createAction(
  ActionTypes.GetChannelMessagesByTimestamp,
  props<{ payload: { timestamp?: string; channelId?: string } }>()
);

export const ResetSenderMessageStatus = createAction(
  ActionTypes.ResetSenderMessageStatus
);

export const GetChannelMessagesByTimestampSuccessful = createAction(
  ActionTypes.GetChannelMessagesByTimestampSuccessful,
  props<{ payload: { channelId: string; channelMessages: ProjectChannelMessageWithRelations[] } }>()
);

export const GetDirectMessagesByTimestamp = createAction(
  ActionTypes.GetDirectMessagesByTimestamp,
  props<{ payload: { timestamp?: string; receiverId?: string } }>()
);

export const GetDirectMessagesByTimestampSuccessful = createAction(
  ActionTypes.GetDirectMessagesByTimestampSuccessful,
  props<{ payload: { receiverId: string; channelMessages: ProjectChannelMessageWithRelations[] } }>()
);

export const CreateChannelMessage = createAction(
  ActionTypes.CreateChannelMessage,
  props<{ payload: { message: ProjectChannelMessageSendChannelMessageRequestDto } }>()
);

export const CreateChannelMessageSuccessful = createAction(
  ActionTypes.CreateChannelMessageSuccessful,
  props<{ payload: { message: ProjectChannelMessageWithRelations } }>()
);

// export const CreateDirectMessage = createAction(
//   ActionTypes.CreateDirectMessage,
//   props<{ payload: { message: any; receiverId?: string } }>()
// );

// export const CreateDirectMessageSuccessful = createAction(
//   ActionTypes.CreateDirectMessageSuccessful,
//   props<{ payload: { message: ProjectChannelMessageWithRelations; receiverId?: string } }>()
// );

export const SendDirectMessage = createAction(
  ActionTypes.SendDirectMessage,
  props<{ payload: { message: any; receiverId?: string; tempId: string } }>()
);

export const SendDirectMessageSuccessful = createAction(
  ActionTypes.SendDirectMessageSuccessful,
  // Add tempId here as well to link back to the original message
  props<{
    payload: {
      userMessage: ProjectChannelMessage;
      aiMessage: ProjectChannelMessage | undefined;
      receiverId?: string;
      tempId: string;
    };
  }>()
);
export const CreateChatMessageFailure = createAction(
  ActionTypes.CreateChatMessageFailure,
  props<{ payload: { messageKey: string } }>()
);

export const CreateAIFunction = createAction(
  ActionTypes.CreateAIFunction,
  props<{ payload: { aiFunctionCall: AiFunctionCall } }>()
);

export const CreateAIFunctionSuccessful = createAction(
  ActionTypes.CreateAIFunctionSuccessful,
  props<{ payload: { aiFunctionCall: AiFunctionCall } }>()
);

export const RealtimeTypingCompleted = createAction(
  ActionTypes.RealtimeTypingCompleted,
  props<{ payload: { message: IChatMessage; channelId?: string } }>()
);

export const SetProjectChannels = createAction(
  ActionTypes.SetProjectChannels,
  props<{ payload: { channels: any[] } }>()
);

export const Error = createAction(
  ActionTypes.Error,
  props<{ payload: { error: { error: any; key: string } } }>()
);

export const AnalyzeDataSource = createAction(
  ActionTypes.AnalyzeDataSource,
  props<{ payload: { dataSourceIds: any; message: any } }>()
);

export const AnalyzeDataSourceSuccessful = createAction(
  ActionTypes.AnalyzeDataSourceSuccessful,
  props<{ payload: { dataSourceIds: any; message: any; correlationId: string; } }>()
);

export const AnalyzeDataSourceFailure = createAction(
  ActionTypes.AnalyzeDataSourceFailure,
  props<{ payload: { error: any; key: string; timestamp: number; message: string } }>()
);

export const GetAnalyzeMessages = createAction(
  ActionTypes.GetAnalyzeMessages
);

export const GetAnalyzeMessagesSuccessful = createAction(
  ActionTypes.GetAnalyzeMessagesSuccessful,
  props<{ payload: { analyzeMessages: any } }>()
);

export const GetAnalyzeMessagesFailure = createAction(
  ActionTypes.GetAnalyzeMessagesFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);
